import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

export default function Dashboard({ user }) {

  const [stats, setStats] = useState({
    totalLoads: 0,
    totalEmployees: 0,
    totalCustomers: 0
  });

  useEffect(() => {
    api.get("/dashboard-stats")
      .then(res => setStats(res.data))
      .catch(() => alert("Failed to load dashboard"));
  }, []);

  return (
    <div className="container mt-3">

      {/* 🔥 CENTER WRAPPER */}
      <div className="mx-auto" style={{ maxWidth: "1100px" }}>

        <h4 className="mb-3">📊 Dashboard</h4>

        <div className="row g-3">

          {/* LOADS */}
          <div className="col-12 col-md-4">
            <Link to="/loads" className="text-decoration-none">
              <div className="card text-white bg-primary h-100 shadow-sm">
                <div className="card-body text-center">
                  <h6 className="card-title">Total Loads</h6>
                  <h3>{stats.totalLoads}</h3>
                </div>
              </div>
            </Link>
          </div>

          {/* EMPLOYEES */}
          {user?.role === "admin" && (
            <div className="col-12 col-md-4">
              <Link to="/employees" className="text-decoration-none">
                <div className="card text-white bg-success h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Employees</h6>
                    <h3>{stats.totalEmployees}</h3>
                  </div>
                </div>
              </Link>
            </div>
          )}

          {/* CUSTOMERS */}
          {user?.role === "admin" && (
            <div className="col-12 col-md-4">
              <Link to="/customers" className="text-decoration-none">
                <div className="card text-white bg-info h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h6 className="card-title">Total Customers</h6>
                    <h3>{stats.totalCustomers}</h3>
                  </div>
                </div>
              </Link>
            </div>
          )}

        </div>

      </div>

    </div>
  );
}